import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function setActivePricingSection(): RootActionTypes {
  return { type: ActionTypes.CLEAR_ACTIVE_PRICING_SECTION };
}
